const toastErrDesc = (error) => {
    // console.log(error)
    if (error?.message) {
        let msg = error?.message
        let errMsg = ''
        if (error?.err_message != null) {
            if (msg !== error?.err_message) {
                errMsg = JSON.stringify(error?.err_message)
            }
        }

        return `${msg} ${errMsg}`
    } else {
        return error
    }
}

const toastVal = (config) => {
    const state = {
        status: "success",
        position: "top",
        variant: "top-accent",
        isClosable: true
    }
    if (config) {
        return { ...state, ...config }
    }
    else {
        return state
    }
}

export { toastErrDesc, toastVal }